import React from 'react';

import tw from '../styles/tailwind';
import IcomoonIcon from './IcomoonIcon';


/**
 * Chevron chico: el chevron de acceso/navegación (NO el de "atrás" del Header).
 * Morado (secondary) y pequeño, como el del listado de Finanzas/Viviendas.
 * Reutilizable en cualquier card o fila navegable.
 */
export default function ChevronChico({ style }: { style?: any }) {
  return <IcomoonIcon name='chevron-right' size={13} color={tw.color('secondary')} style={style} />
}
